import { customerMarketShopfrontApi } from '@envato/foundation-types'
import { ThunkAction } from 'redux-thunk'

import { PageFetchAction } from '../../typings/pageComponent'
import { setSeoMeta } from '../actions/common'
import { getBookmarksForItems } from '../actions/user/bookmark'
import { reportPageType } from '../analytics'
import { reportProductsImpressions } from '../analytics/resultAnalytics'
import { IRootState } from '../reducers'
import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'

export enum TypeKeys {
  GET_FEATURED_PAGE_API_REQUEST = 'GET_FEATURED_PAGE_API_REQUEST',
  GET_FEATURED_PAGE_API_SUCCESS = 'GET_FEATURED_PAGE_API_SUCCESS',
  GET_FEATURED_PAGE_API_FAIL = 'GET_FEATURED_PAGE_API_FAIL'
}

export interface IGetFeaturedPageApiRequestAction {
  type: TypeKeys.GET_FEATURED_PAGE_API_REQUEST
}

export interface IGetFeaturedPageApiSuccessAction {
  type: TypeKeys.GET_FEATURED_PAGE_API_SUCCESS
  payload: Readonly<customerMarketShopfrontApi.featuredItems.IResult>
}

export interface IGetFeaturedPageApiFailAction {
  type: TypeKeys.GET_FEATURED_PAGE_API_FAIL
}

export type ActionTypes =
  | IGetFeaturedPageApiRequestAction
  | IGetFeaturedPageApiSuccessAction
  | IGetFeaturedPageApiFailAction

export const onBeforeFeaturePageView = (): ThunkAction<
  void,
  IRootState,
  void
> => (dispatch, getState) => {
  const { featuredItems } = getState().featuredPage
  const currentSite = getState().common.currentSite

  reportPageType('other')

  if (featuredItems) {
    reportProductsImpressions({
      items: featuredItems.matches,
      currentSite,
      itemRankOffset: 1,
      page: 'Featured Files',
      section: 'Featured Items'
    })
  }
}

export const fetchFeaturedPageDataBySite: PageFetchAction<ThunkAction<
  Promise<ActionTypes>,
  IRootState,
  void
>> = ({ apiAppUrlPrefix }) => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    const requestAction: IGetFeaturedPageApiRequestAction = {
      type: TypeKeys.GET_FEATURED_PAGE_API_REQUEST
    }
    dispatch(requestAction)

    return axiosVerbose
      .get<customerMarketShopfrontApi.featuredItems.IResult>(
        `${apiAppUrlPrefix}/shopfront-api/featured_items/${currentSite}`
      )
      .then(response => {
        const action: IGetFeaturedPageApiSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_FEATURED_PAGE_API_SUCCESS
        }
        if (response.data.featured_items) {
          const itemIds = response.data.featured_items.matches.map(
            item => item.id
          )
          dispatch(getBookmarksForItems(itemIds))
        }
        if (response.data.metadata) {
          dispatch(setSeoMeta(response.data.metadata))
        }
        return dispatch(action)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const action: IGetFeaturedPageApiFailAction = {
          type: TypeKeys.GET_FEATURED_PAGE_API_FAIL
        }
        return dispatch(action)
      })
  }
}
